import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/clipboard-blue-outline.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "lg:w-6 md:w-4 w-3"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConstraintTypeForm = _resolveComponent("ConstraintTypeForm")!
  const _component_SmallCardListWithIcon = _resolveComponent("SmallCardListWithIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SmallCardListWithIcon, {
      endpoint: _ctx.tabelParams.endpoint,
      headerTitle: _ctx.tabelParams.headerTitle,
      buttonTitle: _ctx.tabelParams.buttonTitle,
      confirmDialogDelete: _ctx.tabelParams.confirmDialogDelete,
      showColumnActivate: _ctx.tabelParams.showColumnActivate,
      pageSize: 12,
      masterName: 'Kendala',
      showAction: _ctx.tabelParams.showAction
    }, {
      icon: _withCtx(() => [
        _hoisted_1
      ]),
      form: _withCtx(() => [
        _createVNode(_component_ConstraintTypeForm)
      ]),
      _: 1
    }, 8, ["endpoint", "headerTitle", "buttonTitle", "confirmDialogDelete", "showColumnActivate", "showAction"])
  ]))
}